import React from 'react';
import { ButtonGroup } from '@antonpodolsky/design-system/controls/button-group/button-group';
import { AddonButton } from './addon-button';
import { BROWSER_LIST } from './addon-browsers';

export const AddonButtons = () => (
  <ButtonGroup>
    {BROWSER_LIST.map((browser) => (
      <AddonButton key={browser} browser={browser} />
    ))}
  </ButtonGroup>
);
